import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { toast } from 'react-toastify';

import { updateInstitute } from '@api/institutes';
import { UPDATE_INSTITUTION_TABLE } from '@actions/institution-table/types';
import {
  InstitutionTableActions,
  updateInstitutionTableSuccess,
  updateInstitutionTableFailed,
} from '@actions/institution-table/institution-table-actions';
import { StoreType } from '@reducers/types';
import { isRequestCancelled } from '@helpers/routing';

export const institutionTableMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: InstitutionTableActions) => {
      const nextAction = next(action);
      switch (action.type) {
        case UPDATE_INSTITUTION_TABLE.UPDATE_INSTITUTION_TABLE_REQUEST: {
          try {
            const { payload } = action as any;
            const { data }: any = await updateInstitute(payload);

            dispatch(updateInstitutionTableSuccess(data));
            toast.success('Update Successful!');
          } catch (error: any) {
            if (!isRequestCancelled(error)) {
              toast.error(error.response.data.message);
              dispatch(updateInstitutionTableFailed());
            }
          }
          break;
        }

        default:
          break;
      }
      return nextAction;
    };
  };
};
